import React from 'react';

export interface DonutSegment {
  value: number;
  color: string;
  label?: string;
}

interface ScDonutProps {
  segments: DonutSegment[];
  size?: number;
  thickness?: number;
  center?: React.ReactNode;
}

const ScDonut: React.FC<ScDonutProps> = ({
  segments,
  size = 200,
  thickness = 22,
  center,
}) => {
  const r = (size - thickness) / 2;
  const circumference = 2 * Math.PI * r;
  const total = segments.reduce((s, x) => s + x.value, 0);

  let accumulated = 0;
  const arcs = segments.map((seg, i) => {
    const fraction = total > 0 ? seg.value / total : 0;
    const length = circumference * fraction;
    const dash = `${length} ${circumference - length}`;
    const offset = circumference * (1 - accumulated);
    accumulated += fraction;
    return { ...seg, dash, offset, key: i };
  });

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="var(--paper-2)"
          strokeWidth={thickness}
        />
        {arcs.map(({ color, dash, offset, key }) => (
          <circle
            key={key}
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth={thickness}
            strokeDasharray={dash}
            strokeDashoffset={offset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        ))}
      </svg>
      {center && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'grid',
            placeItems: 'center',
            textAlign: 'center',
          }}
        >
          {center}
        </div>
      )}
    </div>
  );
};

export default ScDonut;
